(() => {
  const path = location.pathname;
  const tarot = /^\/app\/tarot(?:\.html)?$/.test(path);
  const normal = /^\/app\/play(?:\.html)?$/.test(path);
  const id = new URLSearchParams(location.search).get('c');
  const ids = new Set(['2','3','4','6','7','9','10','11','12','13','16','18','19','20','22','23','25','28','30','31','32','34','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','95']);
  if ((!tarot && (!normal || !ids.has(id))) || window.BGSALES || window.BGAFTER?.enabled) return;
  const topics = {
    '그 사람은 나를 어떻게 생각할까':'heart',
    '헤어진 그 사람, 다시 만나게 될까':'reunion',
    '나에게 곧 인연이 올까':'newlove',
    '그 사람도 나에게 마음이 있을까':'crush',
    '우리 둘, 이대로 괜찮을까':'couple',
    '지금 자리를 옮겨도 될까':'work',
    '이 길과 저 길, 어느 쪽이 나을까':'choice',
    '돈이 들어오는 흐름일까':'money',
    '그 사람, 믿어도 될까':'people'
  };
  let dialog, frame, trigger, key, panel, leaving=false;
  const dismiss = () => {
    if (dialog?.open) frame?.contentDocument?.querySelectorAll('video,audio').forEach(media => media.pause());
    if (dialog?.open) dialog.close();
    panel?.removeAttribute('data-question-page');
  };
  const close = () => {
    if (window.BGPAY?.busy()) { window.BGPAY.closeWin?.(); return; }   // 10/8 점검 — 결제 중이면 닫기(X)가 아무 반응이 없었다. play.js 뒤로 가기처럼 결제창만 닫는다
    leaving=true;
    dismiss();
    const home = document.getElementById(tarot ? 'home2' : 'home');
    if (home) home.click(); else location.assign('/#home');
  };
  const another = () => { if (window.BGPAY?.busy()) { window.BGPAY.closeWin?.(); return; } leaving=true; dismiss(); document.getElementById('again')?.click(); };
  const state = () => {
    const menu = window.BGPAY?.menu();
    const children = [...(panel?.children || [])];
    const cut = children.findIndex(el => tarot ? el.id === 'tarotBuy' : el.classList.contains('tocl') || el.classList.contains('toc'));
    const free = cut < 0 ? [] : children.slice(0,cut).filter(el => !el.classList.contains('hr'));
    const available = tarot ? [] : [...(panel?.querySelectorAll('.toc li') || [])].map((li,index) => ({index,available:!li.classList.contains('nope')}));
    return {
      key, tarot,
      price: menu?.애플값 || (menu?.값 ? Number(menu.값).toLocaleString('ko-KR') + '원' : ''),
      count: tarot ? null : menu?.파는 ?? available.filter(part => part.available).length,
      disabled: !menu || !!trigger?.disabled || !!window.BGPAY?.busy(),
      canProceed: !!menu?.탈 || menu?.mode === 'off' || !!menu?.샀나,
      buttonText: menu?.탈 ? '가격 다시 확인' : menu?.샀나 ? '결과 보기' : (window.BGLANG?.sourceText(trigger) ?? trigger?.textContent)?.trim().startsWith('결제 확인') ? '결제 확인' : '전체 풀이 구매하기',
      error: tarot ? document.getElementById('payError')?.textContent || '' : '',
      freeHTML: free.map(el => el.outerHTML).join(''),
      readingCss: document.querySelector('link[href*="reading-format"]')?.href,
      available
    };
  };
  const purchase = () => {
    if (!dialog?.open || !trigger?.isConnected || trigger.disabled || window.BGPAY?.busy()) return;
    trigger.onclick?.call(trigger);
    setTimeout(bind,0);
  };
  window.BGSALES = {state,purchase,close,another};
  const open = (button,nextKey,nextPanel) => {
    trigger=button; panel=nextPanel;
    panel.setAttribute('data-question-page','');
    if (!dialog) {
      const style=document.createElement('style');
      style.textContent='[data-question-page]{display:none!important}body:has(#bg-question-sales[open]) #toast{position:fixed;z-index:101}#bg-question-sales{position:fixed;inset:0;width:100vw;height:100dvh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:#000;overflow:hidden;z-index:100}#bg-question-sales iframe{width:100%;height:100%;border:0;display:block}#bg-question-sales .sales-close{position:absolute;top:max(12px,env(safe-area-inset-top));right:max(12px,env(safe-area-inset-right));width:44px;height:44px;display:grid;place-items:center;padding:0;border-radius:50%;background:var(--glass,rgba(28,28,30,.62));-webkit-backdrop-filter:var(--glass-blur,blur(24px));backdrop-filter:var(--glass-blur,blur(24px));border:.5px solid var(--glass-edge,rgba(255,255,255,.12));color:#fff;font-size:17px;font-weight:600;cursor:pointer}#bg-question-sales .sales-close:focus-visible{outline:2px solid var(--tint,#FFB800);outline-offset:3px}';
      document.head.append(style);
      dialog=document.createElement('dialog'); dialog.id='bg-question-sales'; dialog.setAttribute('aria-label','무료 풀이와 전체 풀이 구매 안내');
      frame=document.createElement('iframe'); frame.title='무료 풀이와 전체 풀이 구매 안내';
      // 10/8 애플 기준 — 닫기는 SF Symbols xmark · 44 · 유리, 이름은 다른 홈 단추와 같은 「홈으로」
      const back=document.createElement('button'); back.type='button'; back.className='sales-close'; back.innerHTML='<span class="sf sf-xmark" aria-hidden="true"></span>'; back.setAttribute('aria-label','홈으로'); back.onclick=close;
      dialog.append(frame,back); document.body.append(dialog);
      dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
    }
    if (key !== nextKey) { key=nextKey; const href='/promo/question-sales/index.html?q='+encodeURIComponent(key);frame.src=window.BGLANG?.link(href) ?? href; }
    if (!dialog.open) dialog.showModal();
  };
  const bind = () => {
    const button=document.getElementById('payBtn');
    if (tarot) {
      const reading=document.getElementById('reading');
      const gate=document.getElementById('tarotBuy');
      if (!reading?.classList.contains('on')) leaving=false;
      if (leaving) return;
      const label=document.querySelector('#rin .rq');
      const topic=topics[(window.BGLANG?.sourceText(label) ?? label?.textContent)?.trim()];
      if (button && topic && reading?.classList.contains('on') && gate && !gate.hidden) open(button,'tarot-'+topic,document.getElementById('rin'));
      else dismiss();
    } else if (!leaving && button?.closest('#vpanel') && document.getElementById('verdict')?.classList.contains('on')) open(button,id,button.closest('#vpanel'));
    else dismiss();
  };
  new MutationObserver(bind).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','disabled','hidden']});
  bind();
})();
